// extracted by mini-css-extract-plugin
export default {"container":"PoweredBySection_container__bDU6E"};